import { Alert, Button } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestsActions } from "../../requests.actions";

const FailedRequestsCreation = () => {
  const dispatch = useDispatch();

  const requestsFailedValue = useSelector(
    (state) => state.requestsStore.requestsFailedValue
  );

  const requestsFailedFile = useSelector(
    (state) => state.requestsStore.requestsFailedFile
  );

  const handleClose = () => {
    dispatch(requestsActions.setRequestsFailedValue(undefined));
    dispatch(requestsActions.clearFailedFile())
    dispatch(requestsActions.fetchRequests());
  };

  const downloadFileRequests = (attachment, filename) => {
    const data = Buffer.from(attachment, 'base64');
    const url = window.URL.createObjectURL(
      new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    )
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
  }

  return (
    <Alert
      banner
      closable
      type="error"
      showIcon={false}
      onClose={handleClose}
      message={requestsFailedValue}
      description={
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div>
          Вы можете скачать отчет по данным заявкам
        </div>
        <Button type="link" onClick={() => downloadFileRequests(requestsFailedFile, 'Заявки ушедшие в ошибку')}>Скачать файл</Button>
      </div>}
    />
  );
}

export default FailedRequestsCreation;